import AxiosInstance from '../AxiosInstance';
import { BASE_URL } from '../Config';

const PATH = 'common/';

const PostFile = (formData) => {
  const url = BASE_URL + PATH + 'file';
  const headers = {
    'accept': 'application/json',
    'content-type': 'multipart/form-data',
  };
  return AxiosInstance.post(url, formData, headers);
};

const DeleteFile = (body) => {
  const url = BASE_URL + PATH + 'file';
  return AxiosInstance.delete(url, { data: body });
};

const GetBusinessType = () => {
  const url = BASE_URL + PATH + 'business-type';
  return AxiosInstance.get(url);
};

const GetMethodology = () => {
  const url = BASE_URL + 'methodology/common';
  return AxiosInstance.get(url);
};

const GetSelectableMethodology = () => {
  const url = BASE_URL + 'methodology/selectable';
  return AxiosInstance.get(url);
};

const GetMonitoring = () => {
  const url = BASE_URL + 'monitoring-evidence/common';
  return AxiosInstance.get(url);
};

const Common = {
  PostFile: PostFile,
  DeleteFile: DeleteFile,
  GetBusinessType: GetBusinessType,
  GetMethodology: GetMethodology,
  GetSelectableMethodology: GetSelectableMethodology,
  GetMonitoring: GetMonitoring,
};

export default Common;
